<template>
  <div>
    <h1>here form order statuses setting page</h1>
  </div>
</template>

<script setup></script>

<style></style>
